<template>
  <div class="driver-wallet-invite main">
    <div class="wrapper no-scrollbar">
      <!-- <button class="delete is-large" /> -->

      <h1 class="subtitle" style="color: #333">
        <span @click="$emit('close')">
          <i class="fa fa-chevron-left" style="padding: 0 6px" />
          Invite and Share
        </span>
        <i
          class="fa fa-qrcode fa-lg is-pulled-right"
          @click="showQR = !showQR"
        />
      </h1>

      <collapse-transition>
        <TukInstallQR v-if="showQR" />
      </collapse-transition>

      <div class="notification is-warning" @click="inviteOwnDriver">
        <p class="subtitle">Your fleet</p>
        <p style="margin-bottom: 10px">
          Please invite other drivers in your fleet to join you on TUK. 🙏🏽
        </p>
        <p>
          Just enter their mobile number and they'll receive an SMS to download
          the app.
        </p>
        <div class="has-text-right">
          <a class="button is-white">
            Invite a driver to join your fleet&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-info">
        <p class="subtitle">New fleet</p>
        <p style="margin-bottom: 10px">
          You can also invite new fleets to join TUK. 👍🏼
        </p>
        <p>Input their contact info and we'll help set them up.</p>
        <div class="has-text-right">
          <a class="button is-white" href="https://m.me/tukapp" target="_blank">
            Invite a new fleet to join TUK&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-primary" @click="shareTUKApp">
        <p class="subtitle">Share TUK</p>
        <p style="margin-bottom: 10px">
          Feel free to share the app to your customers and on social media. 🙌🏽
        </p>
        <p>
          The more people that know about TUK the better it is for the
          community.
        </p>
        <div class="has-text-right">
          <a class="button is-white">
            Share TUK App&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-danger" @click="shareTUKApp">
        <p class="subtitle">Need Help?</p>
        <p style="margin-bottom: 10px">
          Send us a chat message and we'll get back to you ASAP.
        </p>
        <div class="has-text-right">
          <a class="button is-white">
            Chat with us&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TukInstallQR from "@/components/TukInstallQR.vue";

export default {
  components: {
    TukInstallQR,
  },
  props: {
    // workflow: Object, // transport workflow, should be array
  },
  data() {
    return {
      showQR: false,
    };
  },
  computed: {
    role() {
      return this.$store.getters.getDriverRole;
    },
  },
  mounted() {},
  methods: {
    inviteOwnDriver() {
      var r = this.role;
      this.$swal({
        title: "Invite a driver to your fleet",
        text: `${r.business.name} - ${r.workflow_name} - ${r.role_name}`,
        input: "text", //"number",
        inputValue: "+66",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Invite",
        inputValidator: (val) => {
          if (!val || val.length < 10) return "You must enter a mobile number!";
          if (!this.parsePhoneNumber(val)) return "Invalid phone number!";
          var loader = this.loadingDots("orange");
          this.$store
            .dispatch("createRole", {
              phone_number: this.parsePhoneNumber(val),
              business_id: r.business_id,
              workflow_id: r.workflow_id,
              workflow_name: r.workflow_name,
              role_type: r.role_type,
              role_name: r.role_name,
            })
            .then(() => this.success())
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        },
      });
    },
    parsePhoneNumber(raw) {
      var numeric = raw.slice(1); // removes any leading +
      if (!/^\d+$/.test(numeric)) return null;
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return null;
    },
    saveRole(qrPicURL) {
      if (!this.role) {
        this.errorToast("No driver role!");
        return;
      }
      this.role.data.qr_pic_url = qrPicURL;
      var payload = {
        id: this.role.id,
        data: this.role.data,
      };
      this.console("updateRole", payload);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(true);
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.95);
  /* z-index: 21; */
  /* z-index: 1100; */
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow: auto;
}
.subtitle {
  /* color: black; */
  opacity: 0.7;
  font-weight: 450;
  margin-top: 6px;
  margin-bottom: 10px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
p {
  margin-bottom: 10px;
}
.notification {
  padding: 16px;
  margin-bottom: 10px;
}
</style>